<div>
  <div style="margin-left: 80%; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;" mat-raised-button
      color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button (click)="print()" class="noPrint"
      style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5; color: white;" mat-raised-button color="primary">
      Print
    </button>

    <button class="noPrint" style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5; color: white;"
      (click)="exportExcel('issue_seller_Invoice_Register')" mat-raised-button color="primary">
      Export
    </button>

    <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <div id="print-section" style="margin-top: 50px;">
    <table class="table table-bordered" style="width: 90%;margin-left: 30px;border-collapse: collapse;">
      <thead>
        <!-- Top Header Row -->
        <tr style="background-color: #f0f0f0;">
          <th colspan="2" style="border: 1px solid #000; padding: 6px;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
          <th colspan="2" style="border: 1px solid #000; padding: 6px;">अंकाचे नाव : {{ newissuedatepp }}</th>
          <th colspan="2" style="border: 1px solid #000; padding: 6px;">Off. Representative Very Briefly</th>
          <th colspan="2" style="border: 1px solid #000; padding: 6px;">Date: From {{ start_date | date: 'dd-MM-yyyy' }} <br>- To {{ end_date | date: 'dd-MM-yyyy' }} | पृष्ठ क्र: 1</th>
        </tr>

        <!-- Column Titles -->
        <tr style="background-color: #d9d9d9;">
          <th style="border: 1px solid #000; padding: 6px;">Sr</th>
          <th style="border: 1px solid #000; padding: 6px;">Name</th>
          <th style="border: 1px solid #000; padding: 6px;">Issue Seller Amt</th>
          <th style="border: 1px solid #000; padding: 6px;">Discount Amount</th>
          <th style="border: 1px solid #000; padding: 6px;">Total Amt</th>
          <th style="border: 1px solid #000; padding: 6px;">Receive Amt</th>
          <th style="border: 1px solid #000; padding: 6px;">Pending Amt</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let report of filteredinDetailsRegReport; let reportIndex = index">
          <!-- Group Header -->
          <tr style="font-weight: bold; background-color: #e8f0ff;">
            <td colspan="7" style="border: 1px solid #000; padding: 6px;">
              Group Sr: {{ reportIndex + 1 }} - {{ report.off_rep_name }}
            </td>
          </tr>

          <!-- Item Rows -->
          <tr *ngFor="let item of report.advt_data; let itemIndex = index">
            <td style="border: 1px solid #000; padding: 6px;">{{ itemIndex + 1 }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ item.issue_seller_name }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.issue_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.disc_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.total_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.pymt_rcv_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right;">{{ item.total_amt - item.pymt_rcv_amt }}</td>
          </tr>

          <!-- Group Totals -->
          <tr style="font-weight: bold; background-color: #fff;">
            <td colspan="2" style="border: 1px solid #000; text-align: right; padding: 6px;">offrep Total</td>
            <td style="border: 1px solid #000; text-align: right;">{{ report.group_issue_amt_total | number: '1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right;">{{ report.group_discount_total | number: '1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right;">{{  report.group_net_amt_total| number: '1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right;">{{ report.group_received_total | number: '1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right;">{{ report.group_remaining_total | number: '1.2-2' }}</td>
          </tr>
        </ng-container>
      </tbody>

      <tfoot>
        <tr style="font-weight: bold; background-color: lightyellow;">
          <td colspan="2" style="border: 1px solid #000; text-align: right; padding: 6px;">Grand Total</td>
          <td style="border: 1px solid #000; text-align: right;">{{ issue_amt | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ discount | number: '1.2-2' }}</td>
           <td style="border: 1px solid #000; text-align: right;">{{ netamount | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ recivedamt | number: '1.2-2' }}</td>
          <td style="border: 1px solid #000; text-align: right;">{{ remainingamt | number: '1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
